import { put } from "redux-saga/effects";
import { getLatestNewCommandsCount } from "../actions/commands.actions";

export function* loginLogic() {
  yield put(getLatestNewCommandsCount());
}
